/**
 * Error codes to be handled in Form Builder UI.
 */
export const EMPTY_LABEL = 'emptyLabel';
export const NO_OPTIONS = 'noOptions';

export const EMPTY_CODE = 'emptyCode';
export const REPEATED_CODE = 'repeatedCode';

export const INVALID_DATES = 'invalidDates';
export const INVALID_DURATION_VALUE = 'invalidDurationValue';

export const INVALID_TIMES = 'invalidTimes';

export const ALL_ERROR_CODES = [
    EMPTY_LABEL,
    NO_OPTIONS,
    EMPTY_CODE,
    REPEATED_CODE,
    INVALID_DATES,
    INVALID_DURATION_VALUE,
    INVALID_TIMES,
];
